<template>
  <settings-modal
    :locked="isLoading"
    class="t-ob-application-remove-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Are you sure you want to remove this application?</span>

    <error-alert
      :error="error"
      class="mt-4"
    />

    <template slot="actions">
      <v-btn
        class="t-remove-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onRemoveButtonClick"
      >Remove</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal'
  import modal from '@/mixins/modal'
  import form from '@/mixins/form'
  import { mapActions, mapGetters } from 'vuex'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import OpenBankingApi from '@/services/Api/OpenBankingApi'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import flashMessages from '@/mixins/flashMessages'

  export default {
    name: 'OpenBankingAppDeleteModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [modal, form, flashMessages],
    data () {
      return {
        error: undefined,
        isLoading: false,
        deleteApplicationApiRequest: new ApiRequest(OpenBankingApi.deleteApplication)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      application () {
        return this.modal.data.application
      },
      successCallback () {
        return this.modal.data.successCallback
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onRemoveButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.deleteApplicationApiRequest.execute(this.application.id)
          .then(() => {
            this.successCallback()
            this.showSuccessFlashMessage('Application successfully deleted!')
          })
          .catch((error) => this.setError(error))
          .finally(() => this.setIsLoading(false))
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
